import ContentBox from '@components/common/ContentBox';
import PageHeader from '@components/common/PageHeader';
import React, { useCallback, useState } from 'react';
import AudienceSelector, { Audience } from '@components/admin/updater/AudienceSelector';
import UpdateEditor from '@components/admin/updater/UpdateEditor';
import LargeBlueButton from '@components/common/button/LargeBlueButton';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { AnnouncementData } from '@ypp-portal/models/announcement/announcementData';
import TitleEditor from '@components/admin/updater/TitleEditor';
import { useHistory } from 'react-router-dom';
import { Role } from '@ypp-portal/models/user/role';
import { mapFirestoreError } from '@util/mapFirebaseError';
import { AnnouncementDataConverter } from '@data/announcements/AnnouncementDataConverter';

const converter = new AnnouncementDataConverter();

const SendMassUpdate: React.FC = () => {
  const history = useHistory();

  const [audience, setAudience] = useState<Audience>({ roles: [], adminSubroles: [] });
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');

  const [error, setError] = useState('');

  const updateAudience = useCallback((a) => setAudience(a), []);
  const updateTitle = useCallback((t) => setTitle(t), []);
  const updateContent = useCallback((c) => setContent(c), []);

  const submitUpdate = () => {
    const mappedRoles = audience.roles.filter((x) => x !== Role.Admin).map((x) => ({ role: x }));
    const mappedSubRoles = audience.adminSubroles.map((x) => ({ role: Role.Admin, subrole: x }));

    const announcement: AnnouncementData = {
      title,
      content,
      forRoles: mappedRoles.concat(mappedSubRoles),
      forUsers: [],
      created: firebase.firestore.Timestamp.now(),
    };

    firebase
      .firestore()
      .collection('announcements')
      .doc()
      .withConverter(converter)
      .set(announcement)
      .then(() => {
        history.push('/');
      })
      .catch((error: firebase.firestore.FirestoreError) => {
        setError(mapFirestoreError(error));
      });
  };

  return (
    <div className='w-full h-full overflow-auto font-raleway'>
      <PageHeader text='SEND MASS UPDATE'></PageHeader>
      <div className='my-10 mx-14 min-h-2/3'>
        <ContentBox center={false}>
          <AudienceSelector onChange={updateAudience}></AudienceSelector>
          <TitleEditor onChange={updateTitle}></TitleEditor>
          <UpdateEditor onChange={updateContent}></UpdateEditor>
          <LargeBlueButton text='SUBMIT' onClick={submitUpdate}></LargeBlueButton>
          <p className='text-red-600 font-raleway'>{error}</p>
        </ContentBox>
      </div>
    </div>
  );
};

export default SendMassUpdate;
